import { z } from 'zod';
import { changedVersion } from './explain';

/** Most other ways to say one change. */
export const MAX_ALTERNATIVES = 3;

export const AlternativesRequestSchema = changedVersion(
  'The edits to find other words for, in order: what a stretch of the original became.',
).meta({ id: 'AlternativesRequest' });

export type AlternativesRequest = z.infer<typeof AlternativesRequestSchema>;

export const AlternativeSchema = z
  .object({
    change: z.int().nonnegative().describe('Index of the change in the request.'),
    options: z
      .array(z.string())
      .min(1)
      .max(MAX_ALTERNATIVES)
      .describe(
        'Other words for the change’s `after`, each fitting in its place in the rewrite as it stands.',
      ),
  })
  .meta({ id: 'Alternative' });

export type Alternative = z.infer<typeof AlternativeSchema>;

export const AlternativesResponseSchema = z
  .object({ alternatives: z.array(AlternativeSchema) })
  .meta({ id: 'AlternativesResponse' });

export type AlternativesResponse = z.infer<typeof AlternativesResponseSchema>;
